import { axios } from "../config/axios";

const endPoint = '/project/reports';

const getAttendanceDataReport = async (body) => {
    return axios.post(`${endPoint}/attendance-data-report`, body);
}

const downloadAttendanceDataReport = async (body) => {
    return axios.post(`${endPoint}/download-attendance-data-report`, body, {
        responseType: 'blob',
    });
}

const getCandidateResultReport = async (body) => {
    return axios.post(`${endPoint}/candidate-result-report`, body);
}

const downloadCandidateResultReport = async (body) => {
    return axios.post(`${endPoint}/download-candidate-result-report`, body, {
        responseType: 'blob',
    });
}

const getCandidateResponseSheet = async (body) => {
    return axios.post(`${endPoint}/candidate-response-sheet`, body);
}

const downloadCandidateResponseSheet = async (body) => {
    return axios.post(`${endPoint}/download-candidate-response-sheet`, body, {
        responseType: 'blob',
    });
}

const getOverallVerificationReportData = async (body) => {
    return axios.post(`${endPoint}/overall-verification-report`, body);
}

const downloadOverallVerificationReport = async (projectMasterId) => {
    return axios.post(`${endPoint}/download-overall-verification-report`, { projectMasterId }, {
        responseType: 'blob',
    });
}

const getBiometricVerificationReportData = async (body) => {
    return axios.post(`${endPoint}/biometric-verification-report`, body);
}

const downloadBiometricVerificationReport = async (projectMasterId) => {
    return axios.post(`${endPoint}/download-biometric-verification-report`, { projectMasterId }, {
        responseType: 'blob',
    });
}

const getOnlyVerificationStatusReportData = async (body) => {
    return axios.post(`${endPoint}/only-verification-status-report`, body);
}

const downloadOnlyVerificationStatusReport = async (projectMasterId) => {
    return axios.post(`${endPoint}/download-only-verification-status-report`, { projectMasterId }, {
        responseType: 'blob',
    });
}

const getIndividualCandidateReportData = async (body) => {
    return axios.post(`${endPoint}/individual-candidate-report`, body);
}

const downloadIndividualCandidateReport = async (projectMasterId) => {
    return axios.post(`${endPoint}/download-individual-candidate-report`, { projectMasterId }, {
        responseType: 'blob',
    });
}


export {
    getAttendanceDataReport,
    downloadAttendanceDataReport,
    getCandidateResultReport,
    downloadCandidateResultReport,
    getCandidateResponseSheet,
    downloadCandidateResponseSheet,
    getOverallVerificationReportData,
    downloadOverallVerificationReport,
    getOnlyVerificationStatusReportData,
    downloadOnlyVerificationStatusReport,
    getBiometricVerificationReportData,
    downloadBiometricVerificationReport,
    getIndividualCandidateReportData,
    downloadIndividualCandidateReport,
}